import colors from "../base/colors";
import boxShadows from "../base/boxShadows";

import rgba from "../functions/rgba";

const { transparent, grey, background, text } = colors;

const appBar = {
  defaultProps: {
    elevation: 0,
    color: "inherit" as const,
  },

  styleOverrides: {
    root: {
      backgroundColor: background.paper,
      backgroundImage: "none",
      backdropFilter: "blur(10px)",
      borderBottom: `1px solid ${rgba(grey[700], 0.55)}`,
      boxShadow: boxShadows.sm,
      color: text.main,
      padding: "0.25rem 0.5rem",
      transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",

      "& .MuiToolbar-root": {
        minHeight: "auto",
        padding: 0,
      },
    },

    colorPrimary: {
      backgroundColor: background.paper,
      backgroundImage: "none",
      color: text.main,
    },

    colorSecondary: {
      backgroundColor: background.paper,
      backgroundImage: "none",
      color: text.main,
    },

    colorInherit: {
      backgroundColor: background.paper,
      backgroundImage: "none",
      color: text.main,
    },

    colorTransparent: {
      backgroundColor: transparent.main,
      color: text.main,
      boxShadow: "none",
      borderBottom: "none",
    },
  },
};

export default appBar;
